import React, { Fragment, useEffect, useState } from 'react';
import Address from './../Address/Address';
import Axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { EffectFade, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import ScrollFadeIn from '../ScrollFadeIn/ScrollFadeIn'; // ScrollFadeIn 훅을 import
import { useNavigate } from 'react-router-dom';

const Main = () => {
  const [banners, setBanners] = useState([]); // 배너 데이터를 저장할 상태
  const [gameList, setGameList] = useState([]);
  const [newsList, setNewsList] = useState([]); // 뉴스 데이터를 저장할 상태
  const navigate = useNavigate();

  // 메인배너
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await Axios.get('https://www.plassion.co.kr:8444/api/get/user_banner_list', {
          params: {
            type: 1, // type 파라미터에 1을 전송
          },
        });
        const filteredBanners = response.data.filter((banner) => banner.print_status === 'Y');
        setBanners(filteredBanners);
      } catch (error) {
        console.error('배너 데이터 가져오기 오류:', error);
      }
    };

    const fetchGames = async () => {
      try {
        const response = await Axios.get('https://www.plassion.co.kr:8444/api/get/user_games_list');
        setGameList(response.data);
        console.log('gameList', gameList);
      } catch (error) {
        console.error('게임 데이터 가져오기 오류:', error);
      }
    };

    const fetchNews = async () => {
      try {
        const response = await Axios.get('https://www.plassion.co.kr:8444/api/get/news_list'); // 뉴스 API 호출
        setNewsList(response.data);
      } catch (error) {
        console.error('뉴스 데이터 가져오기 오류:', error);
      }
    };

    fetchBanners();
    fetchGames();
    fetchNews();
  }, []);

  // 각 섹션에 ScrollFadeIn 훅을 적용
  const fadeInSection1 = ScrollFadeIn('up', 1, 0.2);
  const fadeInSection2 = ScrollFadeIn('up', 1, 0.4);
  const fadeInSection3 = ScrollFadeIn('up', 1, 0.2);

  const handleListClick = (menu) => {
    navigate(`/board/${menu}`);
  };

  const handleDetailClick = (menu, idx) => {
    const selectedNews = newsList[idx]; // 선택한 게임 데이터
    console.log('selectedNews', selectedNews);
    navigate(`/board/${menu}/${selectedNews.idx}`, { state: { selectedNews } }); // 상태로 게임 데이터 전송
  };

  const handleGamesClick = () => {
    navigate('/board/games');
  };

  return (
    <Fragment>
      <main>
        <section className="first-section" ref={fadeInSection1.ref} style={fadeInSection1.style}>
          <Swiper
            modules={[EffectFade, Pagination, Scrollbar, A11y, Autoplay]}
            slidesPerView={1}
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            autoplay={{
              delay: 3000, // 슬라이드 전환 간격
              disableOnInteraction: false,
              waitForTransition: true, // 전환 대기
            }}
            effect={'fade'}
            fadeEffect={{ crossFade: true }}
            speed={800}
          >
            {banners && banners.length > 0 ? (
              banners.map((banner, index) => (
                <SwiperSlide
                  className="swiper-slide"
                  key={index}
                  onClick={() => banner.url && window.open(banner.url, '_blank')}
                  style={{ cursor: banner.url ? 'pointer' : 'default' }}
                >
                  <div
                    className={`slide-image s-img${index + 1}`}
                    style={{
                      backgroundImage: `url(https://www.plassion.co.kr:8444/${banner.file_url.replace(/\\/g, '/')})`,
                    }}
                  ></div>
                </SwiperSlide>
              ))
            ) : (
              <div>배너가 없습니다.</div>
            )}
          </Swiper>
        </section>

        <section className="second-section" ref={fadeInSection2.ref} style={fadeInSection2.style}>
          <div className="second-flx1">
            <h2>GAMES</h2>
            <div className="more-btn" onClick={() => handleListClick('games')}></div>
          </div>
          <div className="game-boxes">
            {gameList && gameList.length > 0 ? (
              gameList.map((game, index) => (
                <div className="game-box" key={index}>
                  <div className="image-container">
                    <img src={`https://www.plassion.co.kr:8444/${game.img1.replace(/\\/g, '/')}`} alt="game" />
                    <div className="games-hover-main" onClick={() => handleGamesClick()}>
                      <p>상세보기</p>
                    </div>
                  </div>
                  <div className="games-content" onClick={() => handleGamesClick()}>
                    <div className="games-left-box">
                      <h3>{game.title}</h3>
                      <h4>{game.genre}</h4>
                    </div>
                    <div className="games-right-box">
                      <div className="detail-more"></div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div>게임 데이터가 없습니다.</div>
            )}
          </div>
        </section>

        <section className="third-section" ref={fadeInSection3.ref} style={fadeInSection3.style}>
          <div className="second-flx2">
            <h2>NEWS</h2>
            <div className="more-btn" onClick={() => handleListClick('news')}></div>
          </div>
          <div className="news-grid">
            {newsList.map((news, index) => (
              <div className="news-box" key={index} onClick={() => handleDetailClick('news', index)}>
                <div className="image-container">
                  <img src={`https://www.plassion.co.kr:8444/uploads/${news.img1}`} alt={news.title} />
                  <div className="news-hover" onClick={() => handleDetailClick('news', index)}>
                    <p>상세보기</p>
                  </div>
                </div>
                <div className="news-content">
                  <h3>{news.title}</h3>
                  <p>{news.content.replace(/<[^>]+>/g, '')}</p>
                  <p className="last-txt">
                    작성일: {new Date(news.date).toISOString().split('T')[0]} &nbsp;조회수: {news.hit}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Address />
    </Fragment>
  );
};

export default Main;
